export default function({
    settings = {},
    updateOptions,
    groupe,
    onlyTo,
    setOnlyTo
}) {

    const hChange = (selected) => {
        console.log({selected});
        
        updateOptions({
            fromdate: selected.from,
            todate: selected.to,
            ever: !!selected.ever
        }) 
    }

    return [
        {
            type: "Datepicker",
            data: {
                type: "between",
                durationInput: true,
                variant: "icon",
                onChange: hChange,
                titles: {
                    main: "Период трансляции",
                    from: "Дата начала трансляции",
                    to: "Дата окончания трансляции"
                },
                data: {
                    disabledType: "past",
                    groupe,
                    onlyTo,
                    setOnlyTo,
                    default: {
                        from: settings.fromdate,
                        to: settings.todate,
                        ever: !!settings?.ever
                    }
                }
            }
        }
    ]
}